import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  Checkbox,
  CircularProgress,
  IconButton,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import axios from '../../../axiosConfig';

const CategoryModifierPopup = ({ open, onClose, categories, preSelectedProductsPopup, onSave }) => {
  const [selectedProducts, setSelectedProducts] = useState(preSelectedProductsPopup);
  const [loading, setLoading] = useState(false);
  const [viewingProducts, setViewingProducts] = useState(false);
  const [currentCategoryProducts, setCurrentCategoryProducts] = useState([]);

  useEffect(()=>{
    setSelectedProducts(preSelectedProductsPopup)
  },[preSelectedProductsPopup])

  const handleCategoryToggle = (category) => {
    setCurrentCategoryProducts(category.cat_products);
    setViewingProducts(true);
  };

  const handleProductToggle = (product) => {
    const currentIndex = selectedProducts.indexOf(product);
    const newChecked = [...selectedProducts];

    if (currentIndex === -1) {
      newChecked.push(product);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setSelectedProducts(newChecked);
  };

  const handleSave = async () => {
    let mapSelectedData = []
    selectedProducts.map((ele)=>{
      mapSelectedData.push(
        {
          'ProductId': ele.ProductId,
          'imageUrl': ele.imageUrl,
          'name': ele.name,
        }
      )
    })
    onSave(mapSelectedData)
    onClose();
    
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {viewingProducts ? (
          <IconButton onClick={() => setViewingProducts(false)}>
            <ArrowBackIcon />
          </IconButton>
        ) : null}
        {viewingProducts ? 'Select Products' : 'Select Categories'}
      </DialogTitle>
      <DialogContent>
        <List>
          {viewingProducts
            ? currentCategoryProducts.map((product) => (
                <ListItem key={product.id} button onClick={() => handleProductToggle(product)}>
                  <ListItemText primary={product.name} />
                  <Checkbox
                    edge="end"
                    checked={selectedProducts.find((ele)=>ele.ProductId == product.ProductId )}
                    tabIndex={-1}
                    disableRipple
                  />
                </ListItem>
              ))
            : categories.map((category) => (
                <ListItem key={category.id} button onClick={() => handleCategoryToggle(category)}>
                  <ListItemText primary={category.name} />
                  {/* <Checkbox
                    edge="end"
                    checked={selectedCategories.indexOf(category) !== -1}
                    tabIndex={-1}
                    disableRipple
                    onClick={() => {
                      const currentIndex = selectedCategories.indexOf(category);
                      const newChecked = [...selectedCategories];

                      if (currentIndex === -1) {
                        newChecked.push(category);
                      } else {
                        newChecked.splice(currentIndex, 1);
                      }

                      setSelectedCategories(newChecked);
                    }}
                  /> */}
                </ListItem>
              ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancel</Button>
        <Button onClick={handleSave} color="primary" disabled={loading}>
          {loading ? <CircularProgress size={24} /> : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CategoryModifierPopup;
